const indexItems = [
  { id: 1, name: '吃瓜爆料网App下载', icon: 'ri-download-2-line', desc: 'iOS/Android双平台最新版' },
  { id: 2, name: '吃瓜爆料网最新地址', icon: 'ri-link', desc: '实时同步有效入口' },
  { id: 3, name: '黑料爆料专区', icon: 'ri-spy-line', desc: '圈内独家重磅消息' },
  { id: 4, name: '反差视频合集', icon: 'ri-contrast-2-line', desc: '博主真实一面曝光' },
  { id: 5, name: '塌房现场追踪', icon: 'ri-alert-line', desc: '明星翻车第一现场' },
  { id: 6, name: '吃瓜热榜', icon: 'ri-fire-line', desc: '实时热度排名更新' },
  { id: 7, name: '匿名投稿通道', icon: 'ri-mail-send-line', desc: '保护隐私安全爆料' },
  { id: 8, name: '常见问题解答', icon: 'ri-question-line', desc: '使用指南与帮助' },
  { id: 9, name: '平台最新动态', icon: 'ri-newspaper-line', desc: '版本更新与维护公告' },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-100">
      <div className="px-4 md:px-6 max-w-7xl mx-auto">
        <div className="mb-10 text-center">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-2">主题索引</h2>
          <p className="text-sm text-foreground-500">快速找到你想看的内容专区</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {indexItems.map((item) => (
            <a
              key={item.id}
              href={`#${item.id <= 3 ? 'app' : item.id === 4 ? 'cards' : item.id === 5 ? 'media' : item.id === 6 ? 'ranking' : item.id === 7 ? 'contact' : item.id === 8 ? 'faq' : 'updates'}`}
              className="group flex items-center gap-4 p-5 bg-background-50 rounded-xl border border-background-200/70 hover:border-primary-200/50 transition-all cursor-pointer no-underline"
            >
              <div className="w-11 h-11 rounded-xl bg-accent-50 flex items-center justify-center flex-shrink-0">
                <i className={`${item.icon} text-xl text-accent-500`}></i>
              </div>
              <div className="min-w-0">
                <h3 className="text-sm font-semibold text-foreground-800 group-hover:text-primary-500 transition-colors truncate">
                  {item.name}
                </h3>
                <p className="text-xs text-foreground-400 mt-0.5">{item.desc}</p>
              </div>
              <div className="flex-shrink-0 text-foreground-300 group-hover:text-primary-400 transition-colors">
                <i className="ri-arrow-right-s-line text-lg"></i>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}